import { Injectable } from '@angular/core';
import { ApolloCache } from '@apollo/client';

@Injectable({
	providedIn: 'root'
})
export class ApolloCacheManager {
	private readonly caches = new Map<string, ApolloCache>();

	public getApolloCache(name: string): ApolloCache | undefined {
		return this.caches.get(name);
	}

	public addCache(name: string, cache: ApolloCache): void {
		this.caches.set(name, cache);
	}
}
